import { useEffect, useRef, useState } from "react";
import TeamsService from "../services/team-service.client";
import { Team } from "../types/teams";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import ViewTeam from "./view";


const ListTeams = () => {
  const ts = useRef<TeamsService>(new TeamsService());
  const nameTimeout = useRef<any>(null);

  const [teams, setTeams] = useState<Team[]>([]);
  const [team, setTeam] = useState<Team | null>(null);
  const [page, setPage] = useState<number>(1);
  const take = 25;
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    fetch();
  }, [page]);

  const fetch = async () => {
    ts.current.list(search, page, take)
      .then((teams: Team[]) => {
        setTeams(teams);
        setPage(1);
      })
      .catch((err: Error) => {
        console.error(err);
      }
      );
  }

  const textEntered = (search: string) => {
    if (nameTimeout.current) clearTimeout(nameTimeout.current);

    setSearch(search);
    nameTimeout.current = setTimeout(() => {
      if (page === 1) {
        fetch();

      } else {
        setPage(1);
      }
    }, 500);
  }

  return (
    <>
      {team && (
        <div className="rc-modal-container" onClick={() => setTeam(null)}>
          <div className="rc-modal-content" onClick={(e) => e.stopPropagation()}>
            <ViewTeam team={team} />
          </div>
        </div>
      )}

      <div className="container-dark">
        <h1>Teams</h1>

        <Row style={{ marginBottom: "1rem" }}>
          <Col>
            <Form.Group controlId="tierName">
              <Form.Label>Name:</Form.Label>
              <input type="text" name="type" value={search} onChange={(e) => textEntered(e.target.value)} className="form-control" />
            </Form.Group>
          </Col>

          <Col xs={1}>
            <Form.Group controlId="tierName">
              <Button style={{ marginTop: "2rem" }} disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</Button>
            </Form.Group>
          </Col>

          <Col xs={1}>
            <Button style={{ marginTop: "2rem" }} disabled={teams?.length < 25} onClick={() => setPage(page - 1)}>Next</Button>
          </Col>
        </Row>

        {!teams || teams.length === 0 && (
          <div className="alert alert-info">
            No teams found.
          </div>
        )}

        {teams && teams.length > 0 && (
          <table className="table table-dark">
            <thead>
              <tr>
                <th>Name</th>
                <th>Owner</th>
                <th>Members</th>
              </tr>
            </thead>
            <tbody>
              {teams.map((team) => (
                <tr key={team.id} onClick={() => setTeam(team)}>
                  <td>
                    <img src={team.icons?.logo} className="logo" />
                    <img className="flag" src={`https://rf2-ui-images-prod.s3.eu-west-1.amazonaws.com/nation-flags/${team.nationality}.svg`} />
                    {team.name}
                  </td>
                  <td>
                    <img src={team.owner.avatar} className="logo" />
                    {team.owner.username}
                  </td>
                  <td>{team.teamMembers.length}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

      </div>
    </>
  );
}

export default ListTeams;